import { Award, Network, ClipboardList, MessagesSquare, Lightbulb, type LucideIcon } from 'lucide-react';
import type { Profile } from '../types/types';

/**
 * Agent medal catalog. Earned state lives server-side:
 *  - 'tools'  → profiles.tools_badge_earned_at (award_tools_badge RPC)
 *  - others   → profiles.badges jsonb keys      (refresh_user_badges RPC)
 * Predicates MUST stay in sync with refresh_user_badges()
 * (supabase/migrations/20260824010000_agent_badges_medals.sql).
 * PARITY: mirrored in mobile/utils/medals.ts — keep both in sync.
 */
export interface MedalDef {
    key: 'tools' | 'props50' | 'reqs50' | 'chat5' | 'sugerencia';
    name: string;
    /** Tooltip: how to obtain it. */
    how: string;
    icon: LucideIcon;
}

export const AGENT_MEDALS: MedalDef[] = [
    { key: 'tools', name: 'Agente Experto', how: 'Completa la lista de Herramientas clave del Panel de Control.', icon: Award },
    { key: 'props50', name: 'Colaboración Efectiva', how: 'Comparte más de 50 propiedades a la Red de Intercambio.', icon: Network },
    { key: 'reqs50', name: 'Conector de Clientes', how: 'Comparte más de 50 requerimientos a la Red de Intercambio.', icon: ClipboardList },
    { key: 'chat5', name: 'Networker', how: 'Chatea sobre coincidencias con colegas de 5 agencias distintas.', icon: MessagesSquare },
    { key: 'sugerencia', name: 'Voz de la Comunidad', how: 'Publica 1 sugerencia en el menú Comunidad → Sugerencias.', icon: Lightbulb },
];

/** Map of medal key → earned_at ISO string (or undefined when not earned). */
export function earnedMedals(profile?: Pick<Profile, 'tools_badge_earned_at' | 'badges'> | null): Record<string, string | undefined> {
    const badges = (profile?.badges || {}) as Record<string, string>;
    return {
        tools: profile?.tools_badge_earned_at || undefined,
        props50: badges.props50,
        reqs50: badges.reqs50,
        chat5: badges.chat5,
        sugerencia: badges.sugerencia,
    };
}

export function medalCount(profile?: Pick<Profile, 'tools_badge_earned_at' | 'badges'> | null): number {
    return Object.values(earnedMedals(profile)).filter(Boolean).length;
}

/** agent_medals.id for the CBR Guatemala agency medal (agencies.medals int[]). */
export const CBR_AGENCY_MEDAL_ID = 3;
